export const COVER_INFO_GET = 'CONTAINERS_COVER_INFO_GET';
export const COVER_INFO_GET_FAILED = 'CONTAINERS_COVER_INFO_GET_FAILED';
export const COVER_INFO_GET_SUCCESS = 'CONTAINERS_COVER_INFO_GET_SUCCESS';

export const WATCH_GET_COVER_INFO = 'CONTAINERS_WATCH_GET_COVER_INFO';
